import type { IconSvgObject } from './types';

const Kettle01Icon: IconSvgObject = [
  ["path", { d: "M7 7H3C2.44772 7 2 7.44772 2 8V12.5858C2 12.851 2.10536 13.1054 2.29289 13.2929L6 17", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.66804 9.32331L6.11094 19.8947C6.05064 21.0391 6.96225 22 8.10817 22H17.8932C19.0391 22 19.9507 21.0392 19.8905 19.8949L19.3341 9.32378C19.1474 5.77592 16.3674 3.00002 13.0011 3C9.63491 2.99998 6.85499 5.77561 6.66804 9.32331Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.5 7H22C22 12 18.8113 12 18.8113 12", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 17C12 14 14 15 14 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M13 3V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Kettle01Icon;
